import confetti from '../../assets/confetti.png';

import '../../styles/days.scss';

const TwentyFive = () => (
  <div className='days small-image'>
    <img src={confetti} alt='confetti' />
  </div>
);

export default TwentyFive;
